interface UserWithRole {
  role?: { code?: string } | string;
}

export function getUserRoleCode(user: UserWithRole | null | undefined): string {
  if (!user?.role) {
    return '';
  }

  if (typeof user.role === 'string') {
    return user.role.toLowerCase();
  }

  return user.role.code?.toLowerCase() || '';
}

export function hasAnyRoleCode(
  user: UserWithRole | null | undefined,
  requiredRoles: string[]
): boolean {
  if (!user || requiredRoles.length === 0) {
    return false;
  }

  const userRoleCode = getUserRoleCode(user);
  const normalizedRequiredRoles = requiredRoles.map((role) => role.toLowerCase());
  return normalizedRequiredRoles.includes(userRoleCode);
}

export function isPlatformAdministrator(user: UserWithRole | null | undefined): boolean {
  return getUserRoleCode(user) === 'admin';
}
